import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { Toast } from './toat';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.headers.has('Ignore-Interceptor')) {
      const headers = request.headers.delete('Ignore-Interceptor');
      const clonedRequest = request.clone({ headers });
      return next.handle(clonedRequest);
    }

    return next.handle(request).pipe(
      catchError((err) => {
        const error = this.extractErrorMessage(err);

        if (err.url != 'https://ipinfo.io/json') {
          if (err.status === 0 || err.statusText === 'Unknown Error') {
            this.router.navigateByUrl('/auth/login');
            this.authenticationService.logout();
            Toast.warning('Something happened, valid and try again');
          } else if (err.status === 401) {
            Toast.warning('Your session has expired, please log in again');
            this.authenticationService.logout();

            this.router.navigateByUrl('/auth/login');
          } else if (err.status === 400) {
            Toast.warning(error);
          } else if (err.status === 403) {
            Toast.warning('You do not have permission to access this resource');
            this.router.navigateByUrl('app/home');
          } else if (err.status === 429) {
            Toast.error(
              'Su cuenta ha sido bloqueada por exceder el número de intentos permitidos, intente más tarde'
            );
            this.authenticationService.logout();
            this.router.navigateByUrl('/auth/login');
          } else {
            Toast.error(error);
          }
        } else {
          const headers = request.headers.delete('Ignore-Interceptor');
          const clonedRequest = request.clone({ headers });
          return next.handle(clonedRequest);
        }
        return throwError(error);
      })
    );
  }

  // err.error trae el body de la respuesta y no siempre es un string (puede ser
  // un objeto JSON del backend), por lo que se debe extraer un mensaje legible
  // antes de mostrarlo en el Toast; de lo contrario SweetAlert lo renderiza como "[object Object]".
  private extractErrorMessage(err: any): string {
    const body = err?.error;

    if (typeof body === 'string' && body.trim()) {
      return body;
    }

    if (body && typeof body === 'object') {
      const message = body.message || body.title || body.detail || body.error;
      if (typeof message === 'string' && message.trim()) {
        return message;
      }
    }

    return err?.statusText || 'Ha ocurrido un error inesperado';
  }
}
